export default __webpack_public_path__ + "static/ICICILOMBARD-fafc6d3a3c6ed716e90fd16165992a37.png";